import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CreateGroupModal.module.css";
import { useState, useRef } from "react";
import { Ok } from "react-ikonate";
import { Modal } from "shared/Modal";
/**
 *
 * Modal used to create a group
 *
 */

export function CreateGroupModal({ isOpen, onClose, onClick, groups }) {
  const [groupName, setGroupName] = useState("");

  // const [syncChecked, setSyncChecked] = useState(false);
  const [errors, setErrors] = useState({
    selectedGroup: "",
    groupName: "",
  });

  const [selectedGroup, setSelectedGroup] = useState([]);
  const [newGroup, setNewGroup] = useState([]);

  const [newFilter, setNewFilter] = useState("");
  const [openDropDown, setOpenDropdown] = useState(false);

  const ref = useRef(null);

  const handleDropdownClick = () => {
    setOpenDropdown(!openDropDown);
    ref.current.focus();
  };

  const sortedData = groups?.filter(
    (org) => org.pinLevel === 2 || (org.pinLevel === 0 && org.iboNumber === 0)
  );

  function filteredData() {
    const newFilterTrimmed = newFilter.trim();

    const suggestGroup = sortedData?.reduce((accumulator, current) => {
      if (!accumulator.find((item) => item.iboNumber === current.iboNumber)) {
        accumulator.push(current);
      }
      return accumulator.sort((a, b) => a.iboNumber - b.iboNumber);
    }, []);

    const finalGroups = suggestGroup.filter(
      (group) =>
        (group.name &&
          group.name.toLowerCase().includes(newFilterTrimmed.toLowerCase())) ||
        (group.iboNumber &&
          group.iboNumber
            .toString()
            .toLowerCase()
            .includes(newFilterTrimmed)) ||
        (group.organizationName &&
          group.organizationName
            .toLowerCase()
            .includes(newFilterTrimmed.toLowerCase()))
    );

    return finalGroups;
  }

  // Error checking
  const validate = () => {
    let tempErrors = {};

    if (selectedGroup.length < 1 || selectedGroup === "") {
      tempErrors = {
        ...tempErrors,
        selectedGroup: "Please select an organization.",
      };
    }

    if (groupName === "") {
      tempErrors = { ...tempErrors, groupName: "Please enter a group name." };
    }

    const matchingRecords = groups.filter(
      (group) => group.iboNumber === selectedGroup[0]
    );

    if (matchingRecords) {
      let existingGroupName = false;

      matchingRecords.forEach((record) => {
        if (record.groups?.some((group) => group.groupName === groupName)) {
          existingGroupName = true;
          return;
        }
      });

      if (existingGroupName) {
        tempErrors = {
          ...tempErrors,
          groupName: "Group name already exists add a different group name.",
        };
      }
    }

    setErrors(tempErrors);
    const hasErrors = Object.keys(tempErrors).length > 0;

    if (hasErrors) {
      return false;
    } else {
      return true;
    }
  };

  // Submit the form or create
  const handleCreate = () => {
    let isValid = validate();

    const groups = {
      name: newGroup.name,
      iboNumber: newGroup.iboNumber,
      pinLevel: newGroup.pinLevel,
      organizationId: newGroup.organizationId,
      organizationName: newGroup.organizationName,
      groups: [
        {
          groupId: newGroup.iboNumber,
          groupName: groupName,
          isAdmin: false,
        },
      ],
      meta: [],
      plugins: [],
      // sync: syncChecked,
    };

    if (isValid) {
      onClick(groups);
      clearFormData();
    }
  };

  const clearFormData = () => {
    setSelectedGroup("");
    setNewGroup("");
    setGroupName("");
    setErrors({
      selectedGroup: "",
      groupName: "",
    });
    onClose();
  };

  if (!isOpen) {
    return "";
  }

  //Group select onClick
  const groupSearchSelect = (group) => {
    setNewGroup(group);
    setSelectedGroup([group.iboNumber, group.name]);

    setNewFilter("");
    setOpenDropdown(false);
  };

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="CREATE GROUP"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.inputContainer}>
              <div className={styles.inputItem}>
                <div className={styles.selectLabel}>Organization:</div>

                <div className={styles.dropDownContainer}>
                  <div
                    className={styles.selected}
                    onClick={handleDropdownClick}
                  >
                    <input
                      type="text"
                      ref={ref}
                      placeholder={
                        selectedGroup.length > 0
                          ? selectedGroup.join(" > ")
                          : "Search by Organization, Group, or IBO #"
                      }
                      value={newFilter}
                      onChange={(e) => {
                        setNewFilter(e.target.value);
                      }}
                    />
                  </div>
                </div>

                {sortedData && openDropDown && (
                  <div className={styles.selectOptions}>
                    <>
                      {filteredData(sortedData, newFilter).map((item, _id) => (
                        <div
                          key={item._id}
                          className={styles.selectOption}
                          onClick={() => {
                            groupSearchSelect(item);
                          }}
                        >
                          <span className={styles.selectOrgName}>
                            {item.iboNumber} &gt; {item.name}
                          </span>
                        </div>
                      ))}
                    </>
                  </div>
                )}
                <span className={styles.errorOrgMsg}>
                  {errors.selectedGroup}
                </span>
              </div>

              <div className={styles.inputItem}>
                <div
                  className={classNames(styles.selectLabel, styles.rightSide)}
                >
                  Group Name:
                </div>

                <input
                  type="text"
                  id="groupNameInput"
                  placeholder="Click to type"
                  className={styles.inputField}
                  onChange={(e) => setGroupName(e.target.value)}
                />
              </div>
              <span className={styles.errorGroupMsg}>{errors.groupName}</span>
            </div>

            <div className={styles.buttonContainer}>
              <button
                className={classNames(styles.button, styles.cancelBtn)}
                onClick={() => clearFormData()}
              >
                CANCEL
              </button>

              <button className={styles.button} onClick={() => handleCreate()}>
                CREATE
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

CreateGroupModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  onSearch: PropTypes.func,
};
